"use client";

import { stegaClean } from "next-sanity";
import { IFooter } from "@/sanity/lib/definitions";
import { resolveI18nText } from "@/sanity/globals/I18n";

const DEFAULT_LABEL = "Ask AI about IQ Capital:";
const DEFAULT_PROMPT =
  "I'm a trader looking for a prop firm. Evaluate IQ Capital (iqcapital.io): how its challenges and rules work, pricing, payouts, and what real traders say about it, and tell me whether it would be a good fit for me.";

const PROVIDERS: {
  name: string;
  href: (prompt: string) => string;
  inset: string;
  viewBox: string;
  icon: React.ReactNode;
}[] = [
  {
    name: "Claude",
    href: (q) => `https://claude.ai/new?q=${q}`,
    inset: "inset-[17.79%_17.87%_17.28%_17.28%]",
    viewBox: "0 0 24.2533 24.2775",
    icon: (
      <path
        d="M4.7584 16.1446L9.54108 13.474L9.61391 13.2313L9.54108 13.1099H9.2983L8.49714 13.0613L5.77806 12.9885L3.39886 12.8671L1.09249 12.7457L0.509828 12.6243L0 11.896L0.0485553 11.5318L0.534106 11.2162L1.23816 11.2648L2.76764 11.3862L5.07401 11.5318L6.74916 11.6289L9.22547 11.9203H9.61391L9.66246 11.7503L9.54108 11.6532L9.44397 11.5561L7.04049 9.95379L4.46707 8.25437L3.10753 7.25898L2.3792 6.77343L2.01504 6.28788L1.86937 5.26823L2.52486 4.5399L3.42313 4.61273L3.64163 4.66129L4.5399 5.36534L6.4821 6.84627L8.98269 8.73992L9.34685 9.03125L9.49252 8.93414L9.5168 8.8613L9.34685 8.59425L8.01159 6.06939L6.55494 3.54452L5.89944 2.50059L5.7295 1.86937C5.65667 1.6266 5.63239 1.38382 5.63239 1.14104L6.36072 0.121388L6.79771 0L7.81737 0.145665L8.20581 0.485551L8.83703 1.9422L9.83241 4.20001L11.4104 7.25898L11.896 8.18153L12.1388 9.00697L12.2116 9.24974H12.3815V9.12836L12.5029 7.38037L12.7457 5.26823L12.9885 2.54914L13.0613 1.77226L13.4498 0.849714L14.1781 0.364163L14.8093 0.631216L15.2949 1.33526L15.222 1.77226L14.955 3.64163L14.3238 6.57921L13.9596 8.56997H14.1781L14.4209 8.30292L15.4162 6.99193L17.0914 4.90406L17.8197 4.05435L18.6937 3.15608L19.2521 2.71908H20.296L21.0486 3.86013L20.7087 5.04973L19.6405 6.40927L18.7423 7.55032L17.4556 9.27402L16.6787 10.6578L16.7515 10.755H16.9214L19.8348 10.1237L21.3885 9.85668L23.2336 9.54107L24.0833 9.92952L24.1804 10.318L23.8406 11.1434L21.8498 11.6289L19.5191 12.1145L16.0475 12.9157L15.9989 12.9399L16.0475 13.0128L17.6012 13.1584L18.281 13.207H19.9319L22.9908 13.4498L23.792 13.9353L24.2533 14.5908L24.1804 15.0764L22.9423 15.7076L21.2914 15.3191L17.407 14.3966L16.096 14.081H15.9018V14.1781L17.0186 15.2706L19.0336 17.0914L21.607 19.4463L21.7284 20.029L21.4128 20.5145L21.0729 20.466L18.8394 18.7665L17.9654 18.0382L16.0232 16.3873H15.9018V16.5573L16.3388 17.2128L18.718 20.7816L18.8394 21.8741L18.6694 22.214L18.0382 22.4567L17.3827 22.3111L15.9746 20.3689L14.518 18.1839L13.3769 16.1931L13.2555 16.2902L12.5515 23.622L12.2359 23.9862L11.5076 24.2775L10.9006 23.792L10.5607 23.0637L10.9006 21.5585L11.2891 19.6163L11.6047 18.0625L11.896 16.1446L12.0659 15.5134V15.4648H11.896L10.4393 17.4798L8.25437 20.466L6.50638 22.3111L6.09366 22.481L5.36534 22.1168L5.43817 21.4371L5.82661 20.8787L8.25437 17.7712L9.71102 15.8532L10.6821 14.7365L10.6578 14.6151H10.585L4.17574 18.7908L3.03469 18.9365L2.54914 18.4509L2.5977 17.7226L2.84047 17.4798L4.78268 16.1446H4.7584Z"
        fill="#E8E8E3"
      />
    ),
  },
  {
    name: "Gemini",
    href: (q) => `https://www.google.com/search?udm=50&aep=11&q=${q}`,
    inset: "inset-[17.8%_17.8%_17.28%_17.27%]",
    viewBox: "0 0 24.2776 24.2777",
    icon: (
      <path
        d="M24.2776 12.1632C21.1277 12.3565 18.1575 13.6948 15.9261 15.9262C13.6947 18.1576 12.3564 21.1279 12.1631 24.2777H12.1145C11.9215 21.1279 10.5832 18.1574 8.3518 15.9258C6.12034 13.6944 3.14984 12.3561 6.82242e-06 12.1632V12.1146C3.14984 11.9217 6.12034 10.5834 8.3518 8.35192C10.5832 6.12046 11.9215 3.14997 12.1145 0.00013039H12.1631C12.3564 3.14985 13.6947 6.12017 15.9261 8.35155C18.1575 10.5829 21.1277 11.9213 24.2776 12.1146V12.1632Z"
        fill="#E8E8E3"
      />
    ),
  },
  {
    name: "ChatGPT",
    href: (q) => `https://chatgpt.com/?q=${q}`,
    inset: "inset-[17.28%_17.71%_16.76%_17.19%]",
    viewBox: "0 0 24.3416 24.6687",
    icon: (
      <path
        d="M22.7364 10.0967C23.2961 8.4169 23.1035 6.57674 22.2084 5.04881C20.8623 2.70524 18.1565 1.49953 15.5138 2.06692C14.3381 0.742498 12.6491 -0.0106735 10.8783 0.000114319C8.17707 -0.00605296 5.7803 1.73312 4.94927 4.30333C3.21393 4.65872 1.71607 5.74495 0.83953 7.28444C-0.516489 9.62183 -0.207361 12.5683 1.60427 14.5726C1.0446 16.2524 1.23733 18.0926 2.13235 19.6206C3.47836 21.9641 6.18425 23.1698 8.82694 22.6024C10.0018 23.9269 11.6916 24.6801 13.4624 24.6685C16.1652 24.6754 18.5628 22.9346 19.3937 20.3622C21.1292 20.0068 22.6269 18.9206 23.5035 17.381C24.8579 15.0437 24.5482 12.0996 22.7372 10.0952L22.7364 10.0967ZM13.4639 23.0564C12.3824 23.058 11.3347 22.6795 10.5044 21.9864C10.5422 21.9665 10.6077 21.9303 10.6501 21.904L15.5624 19.0671C15.8138 18.9243 15.9678 18.6569 15.9663 18.3677V11.4427L18.0424 12.6415C18.0647 12.6523 18.0794 12.6739 18.0825 12.6985V18.4333C18.0794 20.9834 16.0141 23.0511 13.4639 23.0564ZM3.53156 18.8141C2.9896 17.8783 2.79456 16.7813 2.98036 15.7166C3.01658 15.7383 3.08058 15.7775 3.12606 15.8037L8.03829 18.6406C8.28729 18.7865 8.59566 18.7865 8.84544 18.6406L14.8423 15.1778V17.5754C14.8438 17.6 14.8323 17.6239 14.8131 17.6394L9.84761 20.5063C7.63587 21.7799 4.81126 21.0228 3.53232 18.8141H3.53156ZM2.23874 8.09158C2.77839 7.15416 3.63023 6.43721 4.64474 6.06486C4.64474 6.10727 4.64243 6.18204 4.64243 6.23447V11.9091C4.6409 12.1974 4.79509 12.465 5.04561 12.6076L11.0425 16.0698L8.96648 17.2686C8.94567 17.2823 8.91945 17.2846 8.89633 17.2746L3.93012 14.4054C1.723 13.1271 0.965969 10.3033 2.23797 8.09235L2.23874 8.09158ZM19.2958 12.061L13.2991 8.59807L15.375 7.40009C15.396 7.38621 15.422 7.38389 15.4453 7.39392L20.4114 10.2609C22.6224 11.5383 23.3801 14.3668 22.1028 16.5778C21.5625 17.5137 20.7114 18.2307 19.6976 18.6036V12.7595C19.6999 12.4711 19.5464 12.2044 19.2966 12.061H19.2958ZM21.362 8.95115C21.3257 8.92879 21.2617 8.89026 21.2163 8.86404L16.304 6.02709C16.055 5.88139 15.7466 5.88139 15.4968 6.02709L9.49994 9.49001V7.09249C9.49839 7.06782 9.50996 7.04391 9.52923 7.0285L14.4947 4.16379C16.7064 2.88795 19.5341 3.64729 20.8093 5.85979C21.3481 6.79415 21.5431 7.88807 21.3604 8.95115H21.362ZM8.37132 13.2242L6.2945 12.0255C6.27214 12.0147 6.25749 11.9932 6.2544 11.9685V6.23369C6.25595 3.68043 8.32739 1.61132 10.8806 1.61287C11.9607 1.61287 13.006 1.99215 13.8363 2.68288C13.7985 2.70293 13.7337 2.73915 13.6907 2.76537L8.77837 5.60231C8.52705 5.74495 8.37287 6.01167 8.37442 6.30076L8.37132 13.2228V13.2242ZM9.49917 10.7929L12.1704 9.25027L14.8415 10.7921V13.8766L12.1704 15.4184L9.49917 13.8766V10.7929Z"
        fill="#E8E8E3"
      />
    ),
  },
  {
    name: "Grok",
    href: (q) => `https://x.com/i/grok?text=${q}`,
    inset: "inset-0",
    viewBox: "0 0 37.3952 37.3952",
    icon: (
      <>
        <path
          d="M15.6668 22.2199L24.0243 16.0431C24.4341 15.7403 25.0197 15.8584 25.2149 16.3288C26.2424 18.8093 25.7832 21.7903 23.739 23.8371C21.6946 25.8839 18.8502 26.3328 16.2503 25.3104L13.4102 26.6271C17.4838 29.4147 22.4304 28.7253 25.5217 25.6284C27.9735 23.1734 28.733 19.8274 28.0229 16.8099L28.0293 16.8163C26.9997 12.3834 28.2825 10.6116 30.9103 6.98838C30.9724 6.90247 31.0346 6.81656 31.0969 6.72852L27.6389 10.1906V10.1799L15.6647 22.2221"
          fill="#E8E8E3"
        />
        <path
          d="M13.9422 23.7204C11.0184 20.924 11.5225 16.5963 14.0173 14.1008C15.8621 12.2537 18.8846 11.4999 21.523 12.6081L24.3568 11.298C23.8464 10.9286 23.1921 10.5312 22.4413 10.2521C19.0477 8.85391 14.9848 9.54975 12.2261 12.3096C9.57256 14.9662 8.7381 19.0512 10.1711 22.5369C11.2415 25.142 9.48675 26.9848 7.71917 28.8447C7.09279 29.5042 6.46425 30.1634 5.95801 30.8613L13.9401 23.7224"
          fill="#E8E8E3"
        />
      </>
    ),
  },
  {
    name: "Perplexity",
    href: (q) => `https://www.perplexity.ai/search/new?q=${q}`,
    inset: "inset-[17.73%_24.88%_17.35%_24.38%]",
    viewBox: "0 0 18.977 24.2775",
    icon: (
      <path
        d="M15.8923 0.942791L9.48916 7.35206H15.8923V0.942791ZM15.8923 0.942791V2.69751M9.47432 0V24.2775M3.08527 13.76L9.48916 7.35071L15.8923 13.76V22.9483L9.48916 16.539M9.48916 16.539V7.35071M9.48916 16.539L3.08527 22.9483V13.76M15.8923 13.76L9.48847 7.35071M15.8923 13.76L15.8917 16.502H18.6398V7.35071H9.48847M9.48847 7.35071H0.337188V16.502H3.0846L3.08527 13.76L9.48847 7.35071ZM9.48847 7.35206L3.0846 0.942791V7.35206H9.48847Z"
        stroke="#E8E8E3"
        strokeWidth="0.674375"
        strokeMiterlimit="10"
      />
    ),
  },
];

const DEFAULT_LABEL_I18N: Record<string, string> = {
  de: "Frag die KI zu IQ Capital:",
  br: "Pergunte à IA sobre a IQ Capital:",
};

export default function FooterAskAi({
  data,
  language,
}: {
  data: IFooter;
  language: string;
}) {
  const label =
    resolveI18nText(data.askAiLabel, data.askAiLabelI18n, language) ||
    DEFAULT_LABEL_I18N[language] ||
    DEFAULT_LABEL;
  const prompt = encodeURIComponent(
    stegaClean(
      resolveI18nText(
        data.askAiPrompt || DEFAULT_PROMPT,
        data.askAiPromptI18n,
        language,
      ),
    ),
  );

  return (
    <div className="flex flex-col gap-[1.25rem]">
      <p className="mb-0 font-geist text-[1.75rem] leading-none uppercase whitespace-nowrap text-white/[0.45]">
        {label}
      </p>
      <div className="flex items-center gap-[0.831rem]">
        {PROVIDERS.map((provider) => (
          <a
            key={provider.name}
            href={provider.href(prompt)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${stegaClean(label).replace(/:\s*$/, "")}: ${provider.name}`}
            title={provider.name}
            className="relative shrink-0 w-[4.675rem] h-[4.675rem] rounded-[0.25rem] bg-white/10 transition-colors duration-200 hover:bg-white/20"
          >
            <svg
              aria-hidden
              viewBox={provider.viewBox}
              preserveAspectRatio="none"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`absolute ${provider.inset}`}
            >
              {provider.icon}
            </svg>
          </a>
        ))}
      </div>
    </div>
  );
}
